module.exports = __webpack_public_path__ + "static/media/25.c0eecb80.jpg";